<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
  components: {},
  watch: {
    $route(to) {
      document.title = "助教 - " + to.meta.title || '默认标题';
    }
  },
  mounted() {
    document.title = "助教 - " + this.$route.meta.title || '默认标题';
  }
}
</script>

<style>
</style>
